
<div class="modal-body text-center bg-black">
    <webcam (initError)="handleInitError($event)"></webcam>
</div>
<div class="modal-footer">
    <button class="btn btn-success" (click)="take()"><i class="fas fa-camera mr-2"></i>Scatta foto</button>
    <button class="btn btn-secondary" (click)="cancel()">Annulla</button>
</div>
